module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c09"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('strong', [_vm._v("c. 500 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("Confucian Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Kong Qiu (Confucius)")]), _vm._v(" (551–479 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Without question, Confucius is one of the most influential philosophers in human history. For more than two millennia, he has molded the Chinese mind and way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Confucius” is a latinized form of Kong Fuzi (“Master Kong”); his real name was Kong Qiu. He was born in the mid sixth century BCE near present-day Qufu, in south-central China, and grew up poor following the early death of his father. After holding a series of menial jobs, he opened a school and became a teacher during what was a turbulent period in Chinese history, filled with constant warfare and social disorder. Throughout his long career as a teacher and public servant, Confucius sought to restore peace, good governance, and a strong social fabric to China. He believed that the key to any healthy society lies in building strong families, educated leaders, and ethical individuals. Most of his teaching focused on these themes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Confucius looked back to an earlier period of Chinese history, the era of the so-called Sage-Kings, that he believed provided a model of a good society. This was a period when rulers led by example and displayed "), _c('em', [_vm._v("ren")]), _vm._v(" (benevolence, love) toward their subjects. It was also a time when people displayed both "), _c('em', [_vm._v("li")]), _vm._v(" (proper manners and ceremonial behavior) and "), _c('em', [_vm._v("xiao")]), _vm._v(" (respect for one’s parents, elders, and ancestors).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The stress Confucius laid on proper ritual and ceremony may be puzzling to Westerners. Why have elaborate rules about how many times one should bow, how tea should be served, how long one should mourn the death of a parent, and so forth? Confucius believed that such rules help to order our minds, calm our passions, and show proper respect to one another. They are outward symbols of inner harmonies and proprieties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Confucius’s greatest contribution to Chinese culture may lie in the field of education. Largely because of his influence, China and other Eastern cultures have historically placed great importance on educational achievement, learning, and respect for teachers. Many Asian nations, including China, South Korea, and Singapore, observe “Teachers’ Day” as a national holiday. In Taiwan, Teachers’ Day falls on September 28, Confucius’s presumed birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img29"
    }
  }, [_c('em', [_vm._v("A statue of Confucius at Beijing’s Guozijian, or Imperial Academy, which was founded in 1306 and closed in 1905.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/29-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c10"
    }
  }, [_vm._v("Reciprocity (c. 500 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revival of Confucianism (c. 1180)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c43b7ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c09.vue
// module id = 99
// module chunks = 0